<template>
  <h4 class="title">Dados do inscrito</h4>

  <div class="scroll-table">
    <table id="data-table" class="table">
      <tbody>
        <tr v-if="loadingUserData">
          <td class="text-center" colspan="4" style="border-radius: 10px">
            <div class="loading">
              <div class="spinner-border text-light" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <span> Carregando dados... </span>
            </div>
          </td>
        </tr>
        <tr>
          <td class="profile-column-left">
            <table>
              <tbody>
                <tr v-for="field in leftFields" :key="field">
                  <td>
                    <span>{{ field.campo }}: {{ field.dado }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
          <td class="separator">
            <div class="separator-line"></div>
          </td>
          <td class="profile-column-right">
            <table>
              <tbody>
                <tr v-for="field in rightFields" :key="field">
                  <td>
                    <span>{{ field.campo }}: {{ field.dado }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <h4 class="title">Arquivos do inscrito</h4>

  <div class="scroll-table">
    <table id="file-table" class="table">
      <tbody>
        <tr v-if="loadingUserData">
          <td class="text-center" colspan="4" style="border-radius: 10px">
            <div class="loading">
              <div class="spinner-border text-light" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <span> Carregando dados... </span>
            </div>
          </td>
        </tr>
        <tr v-for="file in files" v-else :key="file">
          <td class="spacing">
            <a :href="file.href" target="_blank">
              <button :disabled="file.status === false" class="view">
                <img alt="Visualizar" src="../../assets/svg/lupa_action.svg" />
              </button>
            </a>
            <span>{{ file.documento }}</span>
          </td>
          <!-- teste -->
          <td></td>  
        </tr>
      </tbody>
      <!-- <template v-if="props.item.field === 'action'">
          <div class="buttons">
            <button
              title="Visualizar documento"
              @click="getDocument(file.documento)"
              class="action"
            >
              <img
                alt="Visualizar documento"
                src="../../assets/svg/lupa_action.svg"
              />
            </button>
          </div>
        </template> -->
    </table>
    <!-- teste -->
    <!-- <MessageModal
      :id="pdfModal.id"
      :button="pdfModal.button"
      :functionModal="pdfModal.functionModal"
      :text="pdfModal.text"
      :textButton="pdfModal.textButton"
      :title="pdfModal.title"
    >
      <template #content>
        <div id="contentPDF">
          <a @click="openNewTabPDF(pdfModal.blobURL)"> Abrir em nova aba </a>
          <object :data="pdfModal.blobURL">no support</object>
        </div>
      </template>
    </MessageModal> -->

    <!-- teste -->

  </div>

  <LoadingScreen :show="loadingScreen" />
</template>

<script>
import { Supervisor, UserService } from "../../services";
import LoadingScreen from "../LoadingScreen.vue";
//import { Modal } from "bootstrap";
//import MessageModal from "../MessageModal.vue";

export default {
  components: {
    LoadingScreen,
  },

  name: "Profile",
  data() {
    return {
      loadingUserData: false,
      loadingScreen: false,
      student: null,

      fields: [],

      files: [
        {
          documento: "Carteira de identidade",
          nome: "doc_identidade",
          tipo: 1,
          href: "#",
          status: false
        },
        {
          documento: "CPF",
          tipo: 2,
          nome: "doc_cpf",
          href: "#",
          status: false
        },
        {
          documento: "Diploma",
          nome: "doc_diploma",
          tipo: 3,
          href: "#",
          status: false
        },
        {
          documento: "Certidão de casamento",
          nome: "doc_certidao_casamento",
          tipo: 4,
          href: "#",
          status: false
        },
      ],

      data: {
        id: undefined,

        fields: {
          name: true,
          nome_mae: true,
          nome_pai: true,
          cor: true,
          genero: true,
          cpf: true,
          data_nascimento: true,
          contato: true,
          rg: true,
          orgao_emissor: true,
          orgao_emissor_uf: true,
          nacionalidade: true,
          naturalidade_municipio: true,
          naturalidade_uf: true,
          nome_ies: true,
          data_conclusao_ies: true,
          cep: true,
          endereco: true,
          endereco_uf: true,
          municipio: true,
          bairro: true,
          complemento: true,
          status: true,
        },

        files: {
          doc_identidade: true,
          doc_cpf: true,
          doc_diploma: true,
          doc_certidao_casamento: true,
        },

        observacao: "",
      },
    };
  },

  async created() {
    this.data.id = this.$route.params.id;
    this.loadingScreen = true;
    this.loadingUserData = true;

    let erro = false;

    // Busca os dados do aluno
    await UserService.find(this.data.id).then(
      // Sucesso
      (response) => {
        // Usuário encontrado
        this.student = response;
        console.log(this.student);

        // Verifica se o campo complemento foi preenchido
        let complemento = "";
        if (response.data.complemento != "null") {
          complemento = response.data.complemento;
        }

        this.fields = [
          {
            campo: "Nome completo",
            nome: "name",
            dado: response.name,
          },
          {
            campo: "Nome completo da mãe",
            nome: "nome_mae",
            dado: response.data.nome_mae,
          },
          {
            campo: "Nome completo do pai",
            nome: "nome_pai",
            dado: response.data.nome_pai,
          },
          {
            campo: "Cor",
            nome: "cor",
            dado: response.data.cor,
          },
          {
            campo: "Gênero",
            nome: "genero",
            dado: response.data.genero,
          },
          {
            campo: "CPF",
            nome: "cpf",
            dado: response.data.cpf,
          },
          {
            campo: "Data de nascimento",
            nome: "data_nascimento",
            dado: this.formatDate(response.data.data_nascimento),
          },
          {
            campo: "Contato",
            nome: "contato",
            dado: response.data.contato,
          },
          {
            campo: "RG",
            nome: "rg",
            dado: response.data.rg,
          },
          {
            campo: "Órgão emissor",
            nome: "orgao_emissor",
            dado: response.data.orgao_emissor,
          },
          {
            campo: "UF do órgão emissor",
            nome: "orgao_emissor_uf",
            dado: response.data.orgao_emissor_uf,
          },
          {
            campo: "Nacionalidade",
            nome: "nacionalidade",
            dado: response.data.nacionalidade,
          },
          {
            campo: "Município de naturalidade",
            nome: "naturalidade_municipio",
            dado: response.data.naturalidade_municipio,
          },
          {
            campo: "UF de naturalidade",
            nome: "naturalidade_uf",
            dado: response.data.naturalidade_uf,
          },
          {
            campo: "IES",
            nome: "nome_ies",
            dado: response.data.nome_ies,
          },
          {
            campo: "Ano de conclusão",
            nome: "data_conclusao_ies",
            dado: response.data.data_conclusao_ies,
          },
          {
            campo: "CEP",
            nome: "cep",
            dado: response.data.cep,
          },
          {
            campo: "Endereço",
            nome: "endereco",
            dado: response.data.endereco,
          },
          {
            campo: "UF",
            nome: "endereco_uf",
            dado: response.data.endereco_uf,
          },
          {
            campo: "Município",
            nome: "municipio",
            dado: response.data.municipio,
          },
          {
            campo: "Bairro",
            nome: "bairro",
            dado: response.data.bairro,
          },
          {
            campo: "Complemento",
            nome: "complemento",
            dado: complemento,
          },
          {
            campo: "Status",
            nome: "status",
            dado: response.data.seletivo.sended.status.find(s => s.value === 1)?.name || null,
          },
        ];
      },
      // Erro
      () => {
        // Usuário não encontrado
        alert("Ocorreu um erro. Tente novamente mais tarde.");

        erro = true;
      }
    );

    // Verifica se houve erro na execução de alguma promisse, caso sim, encerra a execução da função
    if (erro) {
      this.loadingScreen = false;
      this.$router.push("/profile");
      return;
    }


    // Verifica se houve erro na execução de alguma promisse, caso sim, encerra a execução da função
    if (erro) return;

    // Buscar documentos do aluno
    for (let file in this.files) {
      // Verifica se houve erro na execução de alguma promisse, caso sim, encerra a execução da função
      if (erro) return;

      let object = this.files[file];
      let type = object.tipo;

      await Supervisor.getDocument(this.data.id, type).then(
        // Sucesso
        (response) => {
          // Documento não encontrado
          if ("error" in response) {
            // console.log(response);
            // Documento encontrado
          } else {
            var blob = new Blob([response.data], {
              type: response.headers["content-type"],
            });
            object.href = URL.createObjectURL(blob);
            object.status = true; 
          }
        }
      );
    }

    this.loadingUserData = false;
    this.loadingScreen = false;
  },


  methods: {
    // teste
    // openNewTabPDF(blobURL) {
    //   window.open(blobURL, "_blank");
    // },

    // openPDFModal() {
    //   this.pdfModal.object = new Modal(
    //     document.getElementById(this.pdfModal.id)
    //   );
    //   this.pdfModal.object.show();
    // },

    // async getDocument(documentId) {
    //   try {
    //     const response = await this.service.getDocument(documentId);

    //     // Cria um Blob com os dados do documento e define o tipo do arquivo
    //     const blob = new Blob([response.data], { type: response.type });

    //     // Cria um URL para o Blob, permitindo abrir o arquivo em uma nova aba
    //     const blobURL = URL.createObjectURL(blob);

    //     // Abre o documento em um modal
    //     this.pdfModal.blobURL = blobURL;
    //     this.openPDFModal();
    //   } catch (error) {
    //     throw new Error("Erro ao carregar documento");
    //   }
    // },

    // teste

    check(fieldName) {
      let address = ["cep", "endereco", "endereco_uf", "municipio", "bairro"];
      switch (fieldName) {
        case "naturalidade_uf":
          this.checkFields(
            fieldName,
            ["naturalidade_municipio"],
            ["naturalidade_municipio"]
          );
          break;

        case "nacionalidade":
          this.checkFields(
            fieldName,
            ["naturalidade_municipio", "naturalidade_uf"],
            ["naturalidade_municipio", "naturalidade_uf"]
          );
          break;

        case "naturalidade_municipio":
          this.checkFields(fieldName, [], ["naturalidade_uf", "nacionalidade"]);
          break;

        case "cep":
        case "endereco":
        case "endereco_uf":
        case "municipio":
        case "bairro":
          if (address.includes(fieldName)) {
            this.checkFields(fieldName, address, address);
          }
          break;
      }
    },

    checkFields(fieldName, arraySelected, arrayDeselected) {
      // Condição para quando seleciona
      if (
        this.checkField.findIndex((field) => field.nome === fieldName) !== -1
      ) {
        if (arraySelected.length === 0) return;
        for (let field of this.fields) {
          if (field.nome === fieldName) continue;
          if (arraySelected.includes(field.nome)) {
            this.checkField.push(field);
          }
        }
      } else {
        // Condição para quando tira a seleção
        if (arrayDeselected.length === 0) return;
        for (let index = 0; index < this.checkField.length; index++) {
          let field = this.checkField[index];

          if (field.nome === fieldName) continue;
          if (arrayDeselected.includes(field.nome)) {
            // Retira o elemento do array
            this.checkField.splice(index, 1);
            index = -1;
          }
        }
      }
    },

    formatDate() {
      // Método que formata a data de submissão
      let date = new Date();
      let day = String(date.getDate()).padStart(2, "0");
      let month = String(date.getMonth() + 1).padStart(2, "0");
      let year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },
  },
  computed: {
    // Divide os campos para o lado esquerdo
    leftFields() {
      return this.fields.slice(0, Math.ceil(this.fields.length / 2));
    },
    // Divide os campos para o lado direito
    rightFields() {
      return this.fields.slice(Math.ceil(this.fields.length / 2));
    },
  },
};
</script>

<style scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

h4.title {
  color: #004a8a;
  font-size: 24px;
  font-weight: bold;
}

td {
  vertical-align: middle;
  font-size: 18px;
  color: #4f4f4f;
  height: 72px;
  border: none;
  padding: 0;
}

span {
  font-weight: bold;

}

td:last-child {
  font-weight: normal;
}

td:last-child {
  border-radius: 0 10px 10px 0;
  font-size: 16px;
}

tbody {
  border-collapse: separate;
  border-spacing: 0;
}

.scroll-table {
  width: auto;
  max-width: 100%;
  overflow: auto;
  margin-bottom: 1rem;
}

.table {
  border-spacing: 0 16px;
  min-width: 740px;
  overflow: auto;
  margin-bottom: 0;
  width: 100%;
  border-collapse: collapse;
}

.inconsistent-box {
  padding: 15px;
  background-color: #004a8a;
  border-radius: 10px;
  color: white;
  max-width: 200px;
  margin: auto;
}

#label-checkbox {
  display: flex;
  justify-content: center;
}

input[type="checkbox"] {
  vertical-align: middle;
  cursor: pointer;
}

input[type="checkbox"]:before {
  content: "";
  display: block;
  width: 25px;
  height: 25px;
  background-color: #004a8a;
  border: solid 3px white;
}

input[type="checkbox"]:checked:after {
  content: "";
  display: block;
  position: relative;
  left: 6px;
  top: -19px;
  border: solid white;
  width: 13px;
  height: 13px;
  background-color: white;
}

#text {
  margin-left: 1.5em;
  cursor: pointer;
}

td.button {
  max-width: 40px;
}

.view {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #004a8a;
  border: none;
  text-align: center;
  vertical-align: middle;
  margin-right: 2em;
}

.view img {
  display: flex;
  margin: auto;
}

.buttons {
  display: flex;
  margin-top: 3em;
  justify-content: space-between;
  flex-wrap: wrap;
  background-color: #000;
}

.buttons button {
  width: 25em;
  padding: 1em;
  border-radius: 10px;
  border: none;
  color: white;
  background-color: #004a8a;
  font-weight: bold;
  font-size: 18px;
}

button:not([disabled]):hover {
  background-color: #5aad31;
  cursor: pointer;
}

button:disabled {
  background-color: #e0e0e0;
  cursor: not-allowed;
}

button .btn-to-approve {
  background-color: #5aad31;
}

.profile-colunm {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.scroll-table {
  width: 100%;
}

.profile-column-left,
.profile-column-right {
  width: 45%;
  vertical-align: top;
}

.separator {
  width: 5%;
  height: 100px;
  text-align: center;
}

.separator-line {
  width: 1px;
  height: 80%;
  padding: 1px;
  background-color: #000000;
}

.spacing{
  padding: 5px;
}


@media (max-width: 576px) {
  button {
    width: 100%;
  }

  .button-container {
    align-items: center;
    flex-direction: column-reverse;
  }

  .btn-to-approve {
    margin-top: 0.5em;
  }

  td:nth-child(1) {
    text-indent: 0;
  }

  td:last-child {
    width: auto;
  }

  #data-table .inconsistent-box {
    width: 200px;
  }
}
</style>
